module.exports = __webpack_public_path__ + "static/img/knowledgenew4.01879c81.png";